import * as React from 'react';
import { NavLink } from 'react-router-dom'

import Divider from '@mui/material/Divider';
import MenuList from '@mui/material/MenuList';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListSubheader from '@mui/material/ListSubheader';


// New configurable icons
import DashboardIcon from '@mui/icons-material/Dashboard';
import POSIcon from '@mui/icons-material/PointOfSale';
import JobCardIcon from '@mui/icons-material/FactCheck';
import WorkOrderIcon from '@mui/icons-material/Assignment';
import InvoiceIcon from '@mui/icons-material/Receipt';

import CustomerIcon from '@mui/icons-material/Person';
import VehiclesIcon from '@mui/icons-material/DirectionsCar';

import ProductCategoriesIcon from '@mui/icons-material/Apps';
import ProductsIcon from '@mui/icons-material/LocalMall';
import ServiceCategoriesIcon from '@mui/icons-material/MiscellaneousServices';
import ServicesIcon from '@mui/icons-material/Build';

import LocationIcon from '@mui/icons-material/PinDrop';

import InventoryStocksIcon from '@mui/icons-material/Inventory';
import InventoryTransactionsIcon from '@mui/icons-material/AutoAwesomeMotion';
import ReservationsIcon from '@mui/icons-material/Bookmark';

import PaymentIcon from '@mui/icons-material/Payment';
import PaymentAllocationIcon from '@mui/icons-material/Checklist';

import EmployeesIcon from '@mui/icons-material/Engineering';
import PayrollIcon from '@mui/icons-material/AttachMoney';

import InsightsIcon from '@mui/icons-material/Insights';

import SettingsIcon from '@mui/icons-material/Settings';
// --- end of new icons ---



export default function SidebarMenu({ onItemClick }) {
    const handleClick = () => {
        if (onItemClick) onItemClick();
    };

    return (
        <MenuList dense>
            <MenuItem component={NavLink} to={`/`} end onClick={handleClick}>
                <ListItemIcon>
                    <DashboardIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Dashboard</ListItemText>
            </MenuItem>

            <Divider />

            <MenuItem component={NavLink} to={`/sales/pos/start`} onClick={handleClick}>
                <ListItemIcon>
                    <POSIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>New Sale</ListItemText>
            </MenuItem>

            <MenuItem component={NavLink} to={`/sales/job-cards`} onClick={handleClick}>
                <ListItemIcon>
                    <JobCardIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Job Cards</ListItemText>
            </MenuItem>
            <MenuItem component={NavLink} to={`/sales/work-orders`} onClick={handleClick}>
                <ListItemIcon>
                    <WorkOrderIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Work Orders</ListItemText>
            </MenuItem>
            <MenuItem component={NavLink} to={`/sales/invoices`} onClick={handleClick}>
                <ListItemIcon>
                    <InvoiceIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Invoices</ListItemText>
            </MenuItem>

            <Divider />
            <MenuItem component={NavLink} to={`/customers`} onClick={handleClick}>
                <ListItemIcon>
                    <CustomerIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Customers</ListItemText>
            </MenuItem>

            <MenuItem component={NavLink} to={`/vehicles`} onClick={handleClick}>
                <ListItemIcon>
                    <VehiclesIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Vehicles</ListItemText>
            </MenuItem>
            <Divider />

            {/* Products section */}
            <ListSubheader sx={{ lineHeight: '30px', mt: 0.5 }}>Products</ListSubheader>
            <MenuItem component={NavLink} to={`/items/categories/products`} onClick={handleClick}>
                <ListItemIcon>
                    <ProductCategoriesIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Product Categories</ListItemText>
            </MenuItem>
            <MenuItem component={NavLink} to={`/items/products`} onClick={handleClick}>
                <ListItemIcon>
                    <ProductsIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>All Products</ListItemText>
            </MenuItem>

            {/* Services section */}
            <ListSubheader sx={{ lineHeight: '30px', mt: 0.5 }}>Services</ListSubheader>
            <MenuItem component={NavLink} to={`/items/categories/services`} onClick={handleClick}>
                <ListItemIcon>
                    <ServiceCategoriesIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Service Categories</ListItemText>
            </MenuItem>
            <MenuItem component={NavLink} to={`/items/services`} onClick={handleClick}>
                <ListItemIcon>
                    <ServicesIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>All Services</ListItemText>
            </MenuItem>

            <Divider />


            <MenuItem component={NavLink} to={`/locations`} onClick={handleClick}>
                <ListItemIcon>
                    <LocationIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Locations</ListItemText>
            </MenuItem>

            <Divider />

            <MenuItem component={NavLink} to={`/inventory/stocks`} onClick={handleClick}>
                <ListItemIcon>
                    <InventoryStocksIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Inventory stocks</ListItemText>
            </MenuItem>
            {/* <MenuItem component={NavLink} to={`/inventory/transactions`} onClick={handleClick}>
                <ListItemIcon>
                    <InventoryTransactionsIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Inventory transactions</ListItemText>
            </MenuItem> */}
            {/* <MenuItem component={NavLink} to={`/inventory/reservations`} onClick={handleClick}>
                <ListItemIcon>
                    <ReservationsIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Inventory reservation</ListItemText>
            </MenuItem> */}
            <Divider />


            {/* Payment section */}
            <MenuItem component={NavLink} to={`/payments`} onClick={handleClick}>
                <ListItemIcon>
                    <PaymentIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Payments</ListItemText>
            </MenuItem>
            <MenuItem component={NavLink} to={`/payments/allocations`} disabled onClick={handleClick}>
                <ListItemIcon>
                    <PaymentAllocationIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Payment allocations</ListItemText>
            </MenuItem>
            <Divider />

            <MenuItem component={NavLink} to={`/employees`} onClick={handleClick}>
                <ListItemIcon>
                    <EmployeesIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Employees</ListItemText>
            </MenuItem>

            <MenuItem component={NavLink} to={`/pos`} disabled onClick={handleClick}>
                <ListItemIcon>
                    <PayrollIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Payroll</ListItemText>
            </MenuItem>

            <Divider />

            <MenuItem component={NavLink} to={`/insights`} disabled onClick={handleClick}>
                <ListItemIcon>
                    <InsightsIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Business Insights</ListItemText>
            </MenuItem>

            <Divider />

            <MenuItem disabled onClick={handleClick}>
                <ListItemIcon>
                    <SettingsIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Settings</ListItemText>
            </MenuItem>
        </MenuList>
    );
}
